import { motion } from 'framer-motion'
import { useState } from 'react'

const testimonials = [
  {
    quote:
      "Bhai, the reel went viral on our group. Everyone was asking who edited it. 12K views in 2 days — I've never had anything blow up like this.",
    name: 'Rahul S.',
    role: 'Club Cricketer, Delhi',
    stat: '12K Views in 2 Days',
    statIcon: '📈',
    emoji: '🏏',
    color: '#00ff88',
  },
  {
    quote:
      "I uploaded Saturday's match and had my highlight reel by Sunday morning. The editing quality is actually insane — looks like IPL production.",
    name: 'Arjun M.',
    role: 'Amateur Batsman, Mumbai',
    stat: 'Delivered in 18 hrs',
    statIcon: '⚡',
    emoji: '🎬',
    color: '#ffd700',
  },
  {
    quote:
      "Mera six highlight dekh ke Coach ne mujhe first XI mein liya. Serious. Sent the reel to the selector WhatsApp group and got a call the next day.",
    name: 'Vikram T.',
    role: 'All-Rounder, Pune',
    stat: 'Selected for First XI',
    statIcon: '🏆',
    emoji: '⭐',
    color: '#a78bfa',
  },
  {
    quote:
      "Our whole team ordered reels after one match. The way they picked out every wicket, every boundary — it felt personal. Worth every rupee.",
    name: 'Suresh K.',
    role: 'Team Captain, Bengaluru',
    stat: 'Whole Team Ordered',
    statIcon: '👥',
    emoji: '🎯',
    color: '#f472b6',
  },
  {
    quote:
      "The desktop tool is a gem — totally free and the UI is super clean. Clipped an entire match in 20 minutes. Perfect for coaches.",
    name: 'Prashant N.',
    role: 'Cricket Coach, Hyderabad',
    stat: 'Full Match in 20 min',
    statIcon: '🖥️',
    emoji: '🏟️',
    color: '#38bdf8',
  },
  {
    quote:
      "My batting clip hit 5K views on Instagram Reels organically. The music choice, the slow-mo on my cover drive — they just get cricket.",
    name: 'Deepak R.',
    role: 'Opening Batsman, Chennai',
    stat: '5K Organic Views',
    statIcon: '🔥',
    emoji: '🦁',
    color: '#fb923c',
  },
]

function StarRating() {
  return (
    <div className="flex gap-0.5 mb-4">
      {[...Array(5)].map((_, i) => (
        <svg key={i} className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  )
}

export default function Testimonials() {
  const [hoveredIndex, setHoveredIndex] = useState(null)

  return (
    <section className="py-20 md:py-28 px-4 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-pitch-green/[0.04] rounded-full blur-[200px]" />
      </div>

      {/* Section divider */}
      <div className="section-divider max-w-4xl mx-auto mb-20" />

      <div className="container mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-block text-xs font-bold text-pitch-green uppercase tracking-[0.2em] mb-4">
            Real Players. Real Results.
          </span>
          <h2 className="text-4xl md:text-5xl font-black mb-4">
            <span className="text-white">What Cricketers </span>
            <span className="gradient-text">Are Saying</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-lg mx-auto">
            Over 1,000 reels delivered. Here's what players said.
          </p>
        </motion.div>

        {/* Testimonial Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="relative rounded-2xl p-6 bg-white/[0.03] border border-white/[0.08] hover:border-white/[0.18] transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              {/* Top glow on hover */}
              <div
                className="absolute top-0 left-0 right-0 h-px rounded-t-2xl transition-opacity duration-300"
                style={{
                  background: `linear-gradient(90deg, transparent, ${t.color}60, transparent)`,
                  opacity: hoveredIndex === i ? 1 : 0,
                }}
              />

              {/* Stars */}
              <StarRating />

              {/* Quote */}
              <p className="text-gray-300 text-sm leading-relaxed flex-1 mb-6 italic">
                "{t.quote}"
              </p>

              {/* Outcome stat pill */}
              <div
                className="inline-flex items-center gap-2 rounded-lg px-3 py-2 mb-5 w-fit text-sm font-black"
                style={{
                  backgroundColor: t.color + '15',
                  color: t.color,
                  border: `1px solid ${t.color}30`,
                }}
              >
                <span>{t.statIcon}</span>
                <span>{t.stat}</span>
              </div>

              {/* Attribution */}
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-lg flex-shrink-0"
                  style={{ backgroundColor: t.color + '15' }}
                >
                  {t.emoji}
                </div>
                <div>
                  <p className="text-white font-bold text-sm">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Instagram CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <a
            href="https://www.instagram.com/reelcricket.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-pink-500/30 bg-pink-500/10 hover:bg-pink-500/20 transition-all hover:scale-105 text-pink-400 hover:text-pink-300 font-semibold text-sm"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            See all our work on Instagram ↗
          </a>
        </motion.div>
      </div>
    </section>
  )
}
